import type { AskReply } from './askTakiClient.js';
import type { LiaUnread } from './LiaLauncher.js';

export function liaUnread(reply: Pick<AskReply, 'status' | 'steps'>): LiaUnread {
  return reply.status === 'paused' || reply.steps?.some((step) => step.state === 'error') ? 'error' : 'ready';
}
